import {
  SETTINGS,
  SETTINGS_PRIMARY_CONTACT,
  SETTINGS_ACCOUNTS,
  SETTINGS_GENERAL,
  SETTINGS_BRAND,
  SETTINGS_STORE,
  RETAILER_CLAIMS,
} from 'shared/routes'

export const ZENDESK_TICKET_URL =
  'https://mulberrytechnology.zendesk.com/agent/tickets/'

export const PARTNER_FILTER_PERIODS = [
  {
    value: 'Week',
    subtract: { days: 7 },
  },
  {
    value: 'Month',
    subtract: { months: 1 },
  },
  {
    value: '6 Months',
    subtract: { months: 6 },
  },
]

export const RolesAppMapping = Object.freeze({
  ADMIN: {
    role: 'admin',
  },
  MB_USER: {
    role: 'mb_user',
  },
  MB_ADMIN: {
    role: 'mb_admin',
  },
  MB_INTERNAL: {
    role: 'mb_internal',
  },
  PARTNER: {
    role: 'partner',
  },
  PARTNER_LIMITED: {
    role: 'partner_limited',
  },
  PARTNER_ADMIN: {
    role: 'partner_admin',
  },
  CUSTOMER: {
    role: 'customer',
  },
  AUDITOR: {
    role: 'auditor',
  },
  PRICE_UPLOADER: {
    role: 'priceuploader',
  },
  FINANCE: {
    role: 'finance',
  },
})

export const WarrantyIssuedStatus = Object.freeze({
  ISSUED: 'Active',
  CANCELLED: 'Cancelled',
  FULFILLED: 'Fulfilled',
  EXPIRED: 'Expired',
})

export const BLOG_LIMIT = 3

export const SOURCE_CHANNELS = [
  {
    name: 'CUSTOM',
    label: 'Custom',
  },
  {
    name: 'SHOPIFY',
    label: 'Shopify',
  },
  {
    name: 'MAGENTO',
    label: 'Magento',
  },
  {
    name: 'POST_SALE',
    label: 'Post Sale',
  },
  {
    name: 'POST_SALE_ANON',
    label: 'Post Sale Anonymous',
  },
  {
    name: 'IN_STORE',
    label: 'In Store',
  },
]

export const fileClaimBreadcrumbs = [
  {
    name: 'Home',
    link: '/',
  },
  {
    name: 'Create claim',
  },
]

export const settingsTabs = [
  {
    label: 'Company Information',
    href: SETTINGS,
    icon: '',
  },
  {
    label: 'Primary Contact',
    href: SETTINGS_PRIMARY_CONTACT,
    icon: '',
  },
  {
    label: 'Accounts',
    href: SETTINGS_ACCOUNTS,
    icon: '',
  },
  {
    label: 'Settings',
    href: SETTINGS_GENERAL,
    icon: '',
  },
  {
    label: 'Branding',
    href: SETTINGS_BRAND,
    icon: '',
  },
  {
    label: 'Store',
    href: SETTINGS_STORE,
    icon: '',
  },
  {
    label: 'Claims',
    href: RETAILER_CLAIMS,
    icon: '',
    requiresClaims: true,
  },
]

export const adminTabs = [
  {
    label: 'Company Information',
    href: '/retailers/:uuid',
    icon: '',
  },
  {
    label: 'Primary Contact',
    href: '/retailers/:uuid/personal-information',
    icon: '',
  },
  {
    label: 'Accounts',
    href: '/retailers/:uuid/settings/accounts',
    icon: '',
  },
  {
    label: 'Settings',
    href: '/retailers/:uuid/general',
    icon: '',
  },
  {
    label: 'Branding',
    href: '/retailers/:uuid/settings/brand',
    icon: '',
  },
  {
    label: 'Stores',
    href: '/retailers/:uuid/stores',
    icon: '',
  },
  {
    label: 'Shipping Insurance',
    href: '/retailers/:uuid/shipping-insurance',
    icon: '',
  },
  {
    label: 'Welcome Email',
    href: '/retailers/:uuid/welcome-email',
    icon: '',
  },
]

/* eslint-disable */
export const websiteRegex =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
/* eslint-disable */

export const mockPayload = [
  {
    cost: '50.00',
    country_code: 'US',
    country_name: 'United States',
    coverage_details: [
      {
        long: [
          'Stains, rips & tears',
          'Burn & heat marks',
          'Seam separation',
          'Broken zippers & buttons',
          'Damage from liquid marks & rings',
          'Broken mirrors & glass',
          'Loss of mirror silvering',
          'Chipped, dented & scratched surfaces',
          'Bubbling, cracked & peeling finishes',
          'Product defects, once the manufacturer’s warranty expires',
          'Online claims filing',
          '24/7 customer support',
        ],
        short: [
          'Stains, rips & tears',
          'Burn & heat marks',
          'Seam separation',
          'Broken zippers & buttons',
          'Online claims filing',
          '24/7 customer support',
        ],
      },
    ],
    created_date: '2020-12-13 03:15:47.048659+00:00',
    currency: 'USD',
    customer_cost: '50.00',
    duration_months: '12',
    external_product_id: null,
    id: '518539',
    insurer_category: 'furniture_preferred',
    insurer_category_translations: [
      {
        field_json_value:
          "{'long': ['Dommages causés par une surtension', 'Remplacement des produits qui nécessitent plus de 3 fois la même réparation', \"Pannes électriques et mécaniques, incluant l'usure normale\", 'Réclamation sans frais', 'Pas de reçu nécessaire pour faire une réclamation', 'Service client 24/7'], 'short': ['Dommages causés par une surtension', 'Remplacement des produits qui nécessitent plus de 3 fois la même réparation', \"Pannes électriques et mécaniques, incluant l'usure normale\", 'Réclamation sans frais', 'Pas de reçu nécessaire pour faire une réclamation', 'Service client 24/7']}",
        field_name: 'coverage_details',
        language_code: 'fr-CA',
      },
      {
        field_json_value:
          "{'long': ['Mechanical or electrical failure from a power surge', 'Auto replacement for more than 3 of the same repair', 'Receiptless claims process', '24/7 customer support'], 'short': ['Damage from power surge ', 'Auto replacement for >3 of the same repair', 'Receiptless claims process', '24/7 customer support']}",
        field_name: 'coverage_details',
        language_code: 'en',
      },
    ],
    mb_category: 'furniture',
    meta: null,
    policy_terms_url:
      'https://develop.getmulberry.com/documents/213645_consumer_electronic_terms.pdf',
    product: {
      name: 'Credenza',
      price: '99.00',
      retailer: {
        company_name: 'CXM',
        customer_support_email: null,
        customer_support_phone: null,
        integration: 'shopify',
        retailer_claim_flow: false,
      },
    },
    recommended: false,
    service_type: 'NaN',
    warranty_hash:
      '982557a303dce6839fac6ef7121d45c5ebd0542bdc5e31f7422e252572e10e57',
    warranty_offer_id: 'fb666c94-91c0-4725-ac0c-4e8eda5f4bb8',
  },
  {
    cost: '123.00',
    country_code: 'US',
    country_name: 'United States',
    coverage_details: [
      {
        long: [
          'Stains, rips & tears',
          'Burn & heat marks',
          'Seam separation',
          'Broken zippers & buttons',
          'Damage from liquid marks & rings',
          'Broken mirrors & glass',
          'Loss of mirror silvering',
          'Chipped, dented & scratched surfaces',
          'Bubbling, cracked & peeling finishes',
          'Product defects, once the manufacturer’s warranty expires',
          'Online claims filing',
          '24/7 customer support',
        ],
        short: [
          'Stains, rips & tears',
          'Burn & heat marks',
          'Seam separation',
          'Broken zippers & buttons',
          'Online claims filing',
          '24/7 customer support',
        ],
      },
    ],
    created_date: '2020-12-13 03:15:47.088607+00:00',
    currency: 'USD',
    customer_cost: '123.00',
    duration_months: '24',
    external_product_id: null,
    id: '518540',
    insurer_category: 'furniture_preferred',
    insurer_category_translations: [
      {
        field_json_value:
          "{'long': ['Dommages causés par une surtension', 'Remplacement des produits qui nécessitent plus de 3 fois la même réparation', \"Pannes électriques et mécaniques, incluant l'usure normale\", 'Réclamation sans frais', 'Pas de reçu nécessaire pour faire une réclamation', 'Service client 24/7'], 'short': ['Dommages causés par une surtension', 'Remplacement des produits qui nécessitent plus de 3 fois la même réparation', \"Pannes électriques et mécaniques, incluant l'usure normale\", 'Réclamation sans frais', 'Pas de reçu nécessaire pour faire une réclamation', 'Service client 24/7']}",
        field_name: 'coverage_details',
        language_code: 'fr-CA',
      },
      {
        field_json_value:
          "{'long': ['Mechanical or electrical failure from a power surge', 'Auto replacement for more than 3 of the same repair', 'Receiptless claims process', '24/7 customer support'], 'short': ['Damage from power surge ', 'Auto replacement for >3 of the same repair', 'Receiptless claims process', '24/7 customer support']}",
        field_name: 'coverage_details',
        language_code: 'en',
      },
    ],
    mb_category: 'furniture',
    meta: null,
    policy_terms_url:
      'https://develop.getmulberry.com/documents/213645_consumer_electronic_terms.pdf',
    product: {
      name: 'Credenza',
      price: '99.00',
      retailer: {
        company_name: 'CXM',
        customer_support_email: null,
        customer_support_phone: null,
        integration: 'shopify',
        retailer_claim_flow: false,
      },
    },
    recommended: true,
    service_type: 'NaN',
    warranty_hash:
      'bda5267860b049e5e212d8524d926fef97b7d2fbd3b9635eabff9692990cb375',
    warranty_offer_id: '9f797970-b9c8-4ee1-81e5-fdc50f7fced9',
  },
]

export const sharedModalStyles = {
  content: {
    padding: '0',
    borderRadius: '3px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'initial',
    width: '100%',
    overflow: 'auto',
    height: 'auto',
    maxHeight: '750px',
    maxWidth: '500px',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: '1000',
  },
}

export const customFonts = [
  { name: 'Default', value: 'MuseoSans_500, sans-serif' },
  { name: 'Arial', value: 'Arial, sans-serif' },
  { name: 'Roboto', value: 'Roboto, sans-serif' },
  { name: 'Verdana', value: 'Verdana, sans-serif' },
  { name: 'Georgia', value: 'Georgia, serif' },
  { name: 'Times New Roman', value: 'Times New Roman, serif' },
  { name: 'Times', value: 'Times, serif' },
  { name: 'Courier New', value: 'Courier New, serif' },
  {
    name: 'Montserrat',
    value: 'Montserrat, HelveticaNeue, sans-serif',
  },
  {
    name: 'Freight Display Pro',
    value: 'freight-display-pro, serif',
  },
  {
    name: 'Rajdhani',
    value: 'Rajdhani, sans-serif',
  },
]

export const allUSStates = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
]

export const allCanadaStates = [
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'YT', label: 'Yukon' },
]

export const CustomerRole = new Set([RolesAppMapping.CUSTOMER.role])

/**
 * Domain of the email core generates for a customer who gave only a phone.
 * Must equal '@' + PHONE_ONLY_EMAIL_DOMAIN in core/mulberry/utils/checkout.py.
 */
const FAKE_CUSTOMER_EMAIL_DOMAIN = '@noemail.getmulberry.com'

export const isPlaceholderEmail = (email) =>
  typeof email === 'string' && email.endsWith(FAKE_CUSTOMER_EMAIL_DOMAIN)
